import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau11 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const color = {
        bg: '#080808',
        gold: '#c9a227',
        goldLight: '#f5d76e',
        goldDark: '#8B6914',
        text: '#ffffff',
        textMuted: 'rgba(255,255,255,0.55)',
        cardBg: '#111111',
        cardBorder: 'rgba(201,162,39,0.3)',
        divider: 'rgba(201,162,39,0.2)'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    const matches = dataSchedules[0]?.dataGo?.filter(
        i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden'
    ) || []

    return (
        <div
            id={id}
            style={{
                width: width,
                minHeight: width / 1.3,
                fontFamily: 'SFUHelveticaCondensedBold',
                backgroundColor: color.bg,
                position: 'relative',
                overflow: 'hidden',
                padding: `${px * 2.5}px`
            }}
        >
            {/* Subtle radial gold center glow */}
            <div style={{
                position: 'absolute', top: '30%', left: '50%',
                transform: 'translate(-50%, -50%)',
                width: `${px * 80}px`, height: `${px * 80}px`,
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(201,162,39,0.08) 0%, transparent 70%)',
                zIndex: 0, pointerEvents: 'none'
            }} />

            {/* Corner decorations */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: `${px * 6}px`, height: `${px * 6}px`, borderTop: `${px * 0.4}px solid ${color.gold}`, borderLeft: `${px * 0.4}px solid ${color.gold}`, zIndex: 0 }} />
            <div style={{ position: 'absolute', top: 0, right: 0, width: `${px * 6}px`, height: `${px * 6}px`, borderTop: `${px * 0.4}px solid ${color.gold}`, borderRight: `${px * 0.4}px solid ${color.gold}`, zIndex: 0 }} />
            <div style={{ position: 'absolute', bottom: 0, left: 0, width: `${px * 6}px`, height: `${px * 6}px`, borderBottom: `${px * 0.4}px solid ${color.gold}`, borderLeft: `${px * 0.4}px solid ${color.gold}`, zIndex: 0 }} />
            <div style={{ position: 'absolute', bottom: 0, right: 0, width: `${px * 6}px`, height: `${px * 6}px`, borderBottom: `${px * 0.4}px solid ${color.gold}`, borderRight: `${px * 0.4}px solid ${color.gold}`, zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1 }}>

                {/* ===== HEADER ===== */}
                {/* Gold banner */}
                <div style={{
                    background: `linear-gradient(90deg, ${color.goldDark} 0%, ${color.gold} 30%, ${color.goldLight} 50%, ${color.gold} 70%, ${color.goldDark} 100%)`,
                    padding: `${px * 1.5}px ${px * 2.5}px`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderRadius: `${px * 0.5}px`,
                    marginBottom: `${px * 0.5}px`,
                    boxShadow: `0 4px 20px rgba(201,162,39,0.4)`
                }}>
                    <Image src={dataSeason?.logo} style={{ width: `${px * 9}px`, height: `${px * 9}px`, objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <h1 style={{
                            color: '#000',
                            fontSize: `${px * 4.5}px`,
                            textTransform: 'uppercase',
                            margin: 0,
                            letterSpacing: `${px * 0.5}px`,
                            fontWeight: 900,
                            textShadow: `0 1px 0 rgba(255,255,255,0.3)`
                        }}>
                            {t(titleTemplate(dataSchedules[0]?.dataGo))}
                        </h1>
                    </div>
                    <Image src={img} style={{ width: `${px * 9}px`, height: `${px * 9}px`, objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                </div>

                {/* Season name + round */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: `${px * 2}px`, marginBottom: `${px * 2}px`, paddingTop: `${px * 0.8}px` }}>
                    <div style={{ height: `1px`, flex: 1, background: `linear-gradient(to right, transparent, ${color.gold})` }} />
                    <h2 style={{ color: color.gold, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: 0, letterSpacing: `${px * 0.3}px` }}>
                        {dataSeason?.name}
                        {t(numberRound) === numberRound && ` — ${t('round')} ${numberRound}`}
                        {t(numberRound) && t(numberRound) !== numberRound && ` — ${t(numberRound)}`}
                    </h2>
                    <div style={{ height: `1px`, flex: 1, background: `linear-gradient(to left, transparent, ${color.gold})` }} />
                </div>

                {/* ===== MATCHES — 2 COLUMNS ===== */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: `${px * 1.2}px` }}>
                    {matches.map((i, idx) => (
                        <Item
                            key={`${idx}${new Date()}`}
                            data={i}
                            px={px}
                            classCustom={classCustom}
                            idx={idx}
                            color={color}
                            width={width}
                        />
                    ))}
                </div>

                {/* ===== SPONSORS ===== */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{
                        marginTop: `${px * 2.5}px`,
                        borderTop: `1px solid ${color.gold}`,
                        paddingTop: `${px * 1.5}px`,
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        flexWrap: 'wrap', gap: `${px * 2}px`,
                        background: color.cardBg,
                        borderRadius: `${px * 0.5}px`,
                        padding: `${px * 1.5}px`
                    }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => (
                            <Image key={idx} src={i.logo || config.logo}
                                style={{ height: `${px * 4.5}px`, width: 'auto', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                        ))}
                    </div>
                )}

                {/* FOOTER */}
                <p style={{ textAlign: 'right', color: color.gold, fontSize: `${px * 1.6}px`, marginTop: `${px * 1}px`, opacity: 0.7, letterSpacing: '2px' }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}
                </p>
            </div>
        </div>
    )
}

// ===================== ITEM =====================
const Item = React.memo(
    ({ data, px, classCustom, idx, color, width }) => {
        const { t } = useTranslation()

        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        const cardWidth = `calc(50% - ${px * 0.6}px)`

        return (
            <div style={{
                width: cardWidth,
                background: color.cardBg,
                border: `1px solid ${color.cardBorder}`,
                borderLeft: `${px * 0.5}px solid ${color.gold}`,
                borderRadius: `${px * 0.5}px`,
                padding: `${px * 1.2}px ${px * 1.5}px`,
                display: 'flex',
                alignItems: 'center',
                gap: `${px * 1}px`,
                position: 'relative',
                overflow: 'hidden',
                minHeight: `${px * 10}px`
            }}>
                {/* Large index number */}
                <div style={{
                    position: 'absolute', right: `${px * 1}px`, top: '50%', transform: 'translateY(-50%)',
                    fontSize: `${px * 8}px`, fontWeight: 900,
                    color: 'rgba(201,162,39,0.06)', lineHeight: 1, userSelect: 'none', zIndex: 0
                }}>
                    {String(idx + 1).padStart(2, '0')}
                </div>

                <div style={{ position: 'relative', zIndex: 1, width: '100%', display: 'flex', alignItems: 'center', gap: `${px * 1}px` }}>
                    {/* Match number badge */}
                    <div style={{
                        minWidth: `${px * 5}px`, height: `${px * 5}px`,
                        background: `linear-gradient(135deg, ${color.gold}, ${color.goldDark})`,
                        borderRadius: `${px * 0.3}px`,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0
                    }}>
                        <span style={{ color: '#000', fontSize: `${px * 1.8}px`, fontWeight: 900 }}>
                            {String(idx + 1).padStart(2, '0')}
                        </span>
                    </div>

                    {/* Teams block */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: `${px * 0.3}px`, overflow: 'hidden' }}>
                        {/* Home team row */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: `${px * 0.6}px` }}>
                            <Image src={data?.homeTeam?.logo} style={{ width: `${px * 4}px`, height: `${px * 4}px`, borderRadius: '50%', objectFit: 'cover', border: `1px solid ${color.gold}`, backgroundColor: '#fff', flexShrink: 0 }} />
                            <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} />
                        </div>
                        {/* Away team row */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: `${px * 0.6}px` }}>
                            <Image src={data?.awayTeam?.logo} style={{ width: `${px * 4}px`, height: `${px * 4}px`, borderRadius: '50%', objectFit: 'cover', border: `1px solid rgba(255,255,255,0.3)`, backgroundColor: '#fff', flexShrink: 0 }} />
                            <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} />
                        </div>
                    </div>

                    {/* Time/Score block */}
                    <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: `${px * 0.3}px` }}>
                        {data?.isCompleted ? (
                            <>
                                <div style={{
                                    background: `linear-gradient(135deg, ${color.gold}, ${color.goldDark})`,
                                    borderRadius: `${px * 0.4}px`,
                                    padding: `${px * 0.3}px ${px * 1.2}px`,
                                    color: '#000', fontWeight: 900,
                                    fontSize: `${px * 2.6}px`,
                                    letterSpacing: '1px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    minWidth: `${px * 18}px`
                                }}>
                                    {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                    {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                    {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                    {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                                </div>
                                {data?.hasPenalty && (
                                    <span style={{ color: '#fc0366', fontSize: `${px * 1.2}px`, whiteSpace: 'nowrap' }}>
                                        PK: {data?.homeTeam?.penaltyScore}-{data?.awayTeam?.penaltyScore}
                                    </span>
                                )}
                                <span style={{ color: color.textMuted, fontSize: `${px * 1.2}px`, whiteSpace: 'nowrap' }}>
                                    {formatDateTime(data?.dateTime, 'dateTime')}
                                </span>
                            </>
                        ) : (
                            <>
                                <div style={{
                                    border: `1px solid ${color.gold}`,
                                    borderRadius: `${px * 0.4}px`,
                                    padding: `${px * 0.3}px ${px * 1.2}px`,
                                    color: color.gold,
                                    fontSize: `${px * 2.4}px`,
                                    fontWeight: 'bold',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    minWidth: `${px * 16}px`
                                }}>
                                    {formatDateTime(data?.dateTime, 'time')}
                                </div>
                                <span style={{ color: color.textMuted, fontSize: `${px * 1.2}px`, whiteSpace: 'nowrap', textAlign: 'right' }}>
                                    {formatDateTime(data?.dateTime, 'date')}
                                </span>
                                {data?.stadium && (
                                    <span style={{ color: color.textMuted, fontSize: `${px * 1.1}px`, whiteSpace: 'nowrap', maxWidth: `${px * 14}px`, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {data.stadium}
                                    </span>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

// ===================== NAME =====================
const Name = React.memo(
    ({ name, px, propClass }) => {
        const reSizeBasedOnWidth = () => {
            const el = document.querySelector(`.${propClass}`)
            const container = document.querySelector(`.contain${propClass}`)
            if (!el || !container) return
            const fontSize = window?.getComputedStyle(el)?.fontSize
            el.style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
            if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
        }
        const processInput = () => {
            const el = document.querySelector(`.${propClass}`)
            if (!el) return
            el.innerHTML = name
            el.style.fontSize = px * 2 + 'px'
            reSizeBasedOnWidth()
        }
        React.useEffect(() => { processInput() }, [name])

        return (
            <div className={`contain${propClass}`} style={{ flex: 1, height: `${px * 6}px`, display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                <h2 className={propClass} style={{ color: '#ffffff', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', lineHeight: 1.2, wordBreak: 'break-word', whiteSpace: 'normal', fontSize: `${px * 2}px` }} />
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

// ===================== IMAGE =====================
const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) getBase64(props.src).then(r => setData(r))
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau11, areEqual)
